import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export default class GetFilters {


  getUsuarios = async (body: AuthBodyType, filtersForReports: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/usuarios/getFilters", {
        ...body,
        filtersForReports,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getClientes = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/getFilters", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getLocais = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/local/getFilters", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getConjuntos = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/conjunto/getFilters", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getUnidades = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/unidade/getFilters", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getChamados = async (body: AuthBodyType, chamadosLegado: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/chamados/getFilters", {
        ...body,
        chamadosLegado,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };
}
